import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {cloneObject, getParam} from '../utils/utils';
import {addStepToProcess, editStep, deleteStep, getStep, getProcess, listProcesses, listSteps} from '../utils/utilsProcess';

import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import D3Graphviz from "../components/D3Graphviz";
import ViewStep from "../components/ViewStep";
import ViewProcess from "../components/ViewProcess";
import ViewMetadata from "../components/ViewMetadata";

import StepOptionRow from "../components/StepOptionRow";
import StepFlowRow from "../components/StepFlowRow";
import StepArtefactRow from "../components/StepArtefactRow"
import StepResourceRow from "../components/StepResourceRow"

import Rendition from '../components/Rendition';


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Step extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};
        this.viz = null;
        this.vizEngine = "dot";


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);


        this.dsd = new dsd();

        this.refRevision = React.createRef();

        this.FallBackNavigation = `/`;

    }

    loadProcesses(){
        const onLoad = (optProcesses) => {
            this.setState({ optProcesses });
        };

        const onError = (error) => {
            console.error('Failed to load processes:', error);
        };

        listProcesses(this.dsd, {}, onLoad, onError);
        return;
    }


    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadProcess(id){

        this.setState({renderState: "loading"});

        const onLoad = (Process) => {
            let OfferEdit = false;
            if (this.dsd.loggedon && Process.idUser === this.dsd.user.id){
                OfferEdit = true;
            }

            let renderState = "loaded";
            if (!OfferEdit && (this.state.mode === 'new' || this.state.mode === 'edit' || this.state.mode === 'remove')){
                renderState = "denied";
            }

            this.setState({
                Process: Process,
                idProcess: Process._id,
                OfferEdit: OfferEdit,
                renderState: renderState
            });

            this.FallBackNavigation = `/process/${Process._id}`;

            if (this.state.mode === 'new'){
                this.setState({FormData: {}});
            }

            // Load the process steps for the flow dropdowns
            this.loadProcessSteps(Process);
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load Process"
            });
        };

        getProcess(this.dsd, id, onLoad, onFail);
    };

    loadStep(id, forceViewMode = false){

        this.setState({renderState: "loading"});

        const onLoad = (Step) => {
            let Process = Step.Process || null;
            let OfferEdit = false;
            if (Process && this.dsd.loggedon && Process.idUser === this.dsd.user.id){
                OfferEdit = true;
            }



            let renderState = "loaded";
            let mode = forceViewMode ? "view" : this.state.mode;
            
            // Only check for denied if not forcing view mode
            if (!forceViewMode && !OfferEdit && (this.state.mode === 'edit' || this.state.mode === 'remove')){
                renderState = "denied";
            }

            this.setState({
                Step: Step,
                idStep: Step._id,
                Process: Process,
                idProcess: Process ? Process._id : null,
                FormData: Step,
                OfferEdit: OfferEdit,
                renderState: renderState,
                mode: mode
            });

            if (Process){
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsProcess(Process._id);
                }

                this.FallBackNavigation = `/process/${Process._id}`;
                // Load the process steps for the flow dropdowns
                this.loadProcessSteps(Process);
            }
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load Step"
            });
        };

        getStep(this.dsd, id, onLoad, onFail);
        
    };


    loadProcessSteps(Process, silent = false){

        if (!Process){
            this.setState({
                ProcessSteps: null
            });
            return;
        }

        if (!silent) {
            this.setState({ renderState: "loading" });
        }

        const onLoad = (ProcessSteps) => {
            const stateUpdate = { ProcessSteps };
            if (!silent) {
                stateUpdate.renderState = "loaded";
            }
            this.setState(stateUpdate);
        };

        const onError = (error) => {
            console.error('Failed to load process steps:', error);
            if (!silent) {
                this.setState({
                    renderState: "failed",
                    errorMessage: error.message || "Failed to load process steps"
                });
            }
        };

        listSteps(this.dsd, {idProcess: Process._id}, onLoad, onError);

        return;
        
    };



    setup(){

        let StateChange = {
            mode: "view",
            idStep: null,
            idProcess: null,
            Process: null,
            Step: null,
            renderState: null,
            errorMessage: null,
            FormData: {},
            OfferEdit: false,
            Controls: {}
        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idStep = getParam('id', this.props);
        StateChange.idProcess = getParam('idProcess', this.props);

        this.loadProcesses();

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idProcess){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Process not specified when adding a Step"
                }
                break;
            default:
                if (StateChange.idProcess){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Process should not be specified for an existing Step"
                }
                if (!StateChange.idStep){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Step not specified"
                }
                break;
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);

        if (StateChange.idProcess && StateChange.mode === 'new'){
            this.loadProcess(StateChange.idProcess);
        }
        if (StateChange.idStep){
            this.loadStep(StateChange.idStep);
        }
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        // Define callbacks at top
        const onAdd = (idStep) => {
            this.props.navigation(`/step/${idStep}`);
        };

        const onUpdate = (Step) => {
            
            if (this.refRevision.current) {
                this.refRevision.current.update();
            }
            this.props.navigation(`/step/${this.state.idStep}`);
        };

        const onDelete = () => {
            this.props.navigation(this.FallBackNavigation);
        };

        const onError = (error) => {
            this.setState({
                renderState: error.status,
                errorMessage: error.errorMessage
            });
        };

        window.scrollTo(0, 0);

        switch (event.target.name){
            
            case 'btnCancel':

                switch (this.state.mode){
                    case "edit":
                    case "delete":
                        this.props.navigation(`/step/${this.state.idStep}`);
                    case "new":
                        this.props.navigation(this.FallBackNavigation);
                        break;
                }

                break;

            case 'btnRemove':
                deleteStep(this.dsd, this.state.Process._id, this.state.idStep, onDelete, onError);
                break;

            case 'btnSave':
            default:
                this.setState({
                    renderState: "updating"
                });
        
                switch (this.state.mode){
                    case 'new':
                        addStepToProcess(this.dsd, this.state.idProcess, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editStep(this.dsd, this.state.Process._id, this.state.idStep, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    addFlow(){
        let FormData = {...this.state.FormData};
        FormData.Flows = [...(FormData.Flows || []), {}];
        
        this.setState({"FormData": FormData});
    }

    removeFlow(seq){

       let FormData = {...this.state.FormData};
       FormData.Flows = [...(FormData.Flows || [])];
       FormData.Flows.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});

    }

    updateFlow(seq, Flow){

       let FormData = {...this.state.FormData};
       FormData.Flows = [...(FormData.Flows || [])];
       FormData.Flows[seq-1] = Flow;

       this.setState({"FormData": FormData});

    }

    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'step':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/step/${partsVizNodeId[1]}`);
                    }
                    break;
            }
        }

        event.preventDefault();

    };


    visualise(){
    
        if (!this.state.Step){
            return null;
        }


        try {

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.viz.dot}/>
                    </div>
                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }


        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Step</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Select label="Type" name='type'  onChange={this.handleChange} value={this.state.FormData.type}>
                                        {
                                            Object.keys(this.dsd.model.steps).map(
                                                (modelKey, posModelStep) => 
                                                    {
                                                        let modelStep = this.dsd.model.steps[modelKey];
                                                        return(
                                                            <option key={posModelStep} value={modelStep.name}>{modelStep.label}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <PD.Input label="Organisation" width="30" name="organisation" value={this.state.FormData.organisation} onChange={this.handleChange}/>
                                    <PD.Input label="Role" width="30" name="role" value={this.state.FormData.role} onChange={this.handleChange}/>

                                    
                                    {this.FormStepSubProcess()}
                                    {this.FormStepMultiInstance()}
                                    {this.FormStepOptions()}
                                    {this.FormStepFlows()}
                                    {this.FormStepArtefacts()}
                                    {this.FormStepResources()}


                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                        <div>
                                                            <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                            <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                        </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Step</PD.Heading>

                        {this.state.renderState == "error" &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" name="btnRemove" value="confirm remove?" />
                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                        <ViewStep Step={this.state.Step} ProcessSteps={this.state.ProcessSteps}/>

                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Step:{this.state.Step.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />   
                                            <PD.Button type="warning" onClick={this.handleMode} value="remove" /> 
                                    </span>
                                }

                                <ViewStep Step={this.state.Step} ProcessSteps={this.state.ProcessSteps}/>

                                <br/>

                                <PD.Tabs>

                                    <div label='Process'>
                                        <ViewProcess Process={this.state.Process} />
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Step} />
                                    </div>


                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/steps"
                                            id={this.state.idStep}
                                        />
                                    </div>


                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };



    FormStepMultiInstance(){

        if (!this.state.FormData.type){
            return null
        }

        let modelStep = null;
        if (this.state.FormData.type in this.dsd.model.steps){
            modelStep = this.dsd.model.steps[this.state.FormData.type];
        }
        if (!modelStep){
            return null
        }

        switch (modelStep.type){
            case 'bpmn:task':
            case 'bpmn:subprocess':
                return(
                    <div>
                        <PD.Checkbox label="Multi Instance?" name="multiinstance" value={this.state.FormData.multiinstance} onChange={this.handleChange}/>
                        {this.state.FormData.multiinstance &&
                            <PD.Input label="For each" width="30" name="foreach" value={this.state.FormData.foreach} onChange={this.handleChange}/>
                        }
                    </div>
                    )
                break;
        }

        return null;

    }


    FormStepSubProcess(){

        if (!this.state.FormData.type){
            return null
        }

        let modelStep = null;
        if (this.state.FormData.type in this.dsd.model.steps){
            modelStep = this.dsd.model.steps[this.state.FormData.type];
        }
        if (!modelStep){
            return null
        }

        switch (modelStep.type){
            case 'bpmn:subprocess':
                if (this.state.optProcesses){
                    return(
                        <PD.Select label="Sub Process" name='idSubProcess'  onChange={this.handleChange} value={this.state.FormData.idSubProcess}>
                            {
                                this.state.optProcesses.map(
                                    (optProcess, posOptProcess) => 
                                        {
                                            return(
                                                <option key={posOptProcess} value={optProcess._id}>{optProcess.name}</option>
                                            )
                                        }
                                )
                            }
                        </PD.Select>
                    )
                }
                break;
            }

        return null;

    }

    FormStepOptions(){

        if (!this.state.FormData.type){
            return null
        }

        let modelStep = null;
        if (this.state.FormData.type in this.dsd.model.steps){
            modelStep = this.dsd.model.steps[this.state.FormData.type];
        }
        if (!modelStep){
            return null
        }

        let seqNext = 1;

        switch (modelStep.type){
            case 'bpmn:exclusiveor':
            case 'bpmn:inclusiveor':
                if (this.state.FormData.Options){
                    seqNext = this.state.FormData.Options.length + 1;
                }
                return (
                    <div>
                        <PD.Heading level="2">Decision Options</PD.Heading>
                        <PD.Table type="list">
                            <PD.Tr>
                                <PD.Th/>
                                <PD.Th>Option</PD.Th>
                            </PD.Tr>

                            {this.state.FormData.Options &&
                                this.state.FormData.Options.map(
                                    (stepOption, posStepOption) => 
                                    {
                                        let seq = posStepOption+1;
                                        return(
                                            this.FormStepOption('edit', seq, stepOption)
                                        )
                                    }
                                )
                            }
                            {this.FormStepOption('new', seqNext)}
                        </PD.Table>
                    </div>
                );
                break;
        }
        return null;
    }

    FormStepOption(mode, seq,Option = {}){
        let value = "";
        if (!(Option.label === undefined)){
            value = Option.label;
        }
        return(
            <StepOptionRow key={seq.toString()} mode={mode} parent={this} Option={Option} seq={seq}/>
        )
    }

    addOption(){

        let FormData = {...this.state.FormData};
        FormData.Options = [...(FormData.Options || []), {}];
  
       this.setState({"FormData": FormData});

    }

    removeOption(seq){

       let FormData = {...this.state.FormData};
       FormData.Options = [...(FormData.Options || [])];
       FormData.Options.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});

    }


    updateOption(seq, Option){

       let FormData = {...this.state.FormData};
       FormData.Options = [...(FormData.Options || [])];
       FormData.Options[seq-1] = Option;

       this.setState({"FormData": FormData});

    }



    FormStepFlows(){

        let seqNext = 1;
        if (this.state.FormData.Flows){
            seqNext = this.state.FormData.Flows.length + 1;
        }
        return (
            <fieldset>
                <legend>Flows - how to get to this step</legend>
                <PD.Table type="list">
                    {this.state.FormData.Flows &&
                        this.state.FormData.Flows.map(
                            (Flow, posFlow) => 
                            {
                                let seq = posFlow+1;
                                return(
                                    this.FormFlow('edit', seq, Flow)
                                )
                            }
                        )
                    }
                    {this.FormFlow('new', seqNext)}
                </PD.Table>
            </fieldset>
        );

    }

    FormFlow(mode, seq, Flow = {}){
        return(
            <StepFlowRow key={seq.toString()} mode={mode} parent={this} Flow={Flow} seq={seq} selectSteps={this.state.ProcessSteps} idStep={this.state.idStep}/>
        )
    }


    FormStepArtefacts(){

        if (!this.state.FormData.type){
            return null
        }

        let modelStep = null;
        if (this.state.FormData.type in this.dsd.model.steps){
            modelStep = this.dsd.model.steps[this.state.FormData.type];
        }
        if (!modelStep){
            return null
        }

        let seqNext = 1;

        switch (modelStep.type){
            case 'bpmn:activity':
            case 'bpmn:exclusiveor':
            case 'bpmn:inclusiveor':
                if (this.state.FormData.Artefacts){
                    seqNext = this.state.FormData.Artefacts.length + 1;
                }
                return (
                    <fieldset>
                        <legend>Artefacts - inputs and outputs for this step</legend>
                        <PD.Table type="list">
                            {this.state.FormData.Artefacts &&
                                this.state.FormData.Artefacts.map(
                                    (stepArtefact, posStepArtefact) => 
                                    {
                                        let seq = posStepArtefact+1;
                                        return(
                                            this.FormStepArtefact('edit', seq, stepArtefact)
                                        )
                                    }
                                )
                            }
                            {this.FormStepArtefact('new', seqNext)}
                        </PD.Table>
                    </fieldset>
                );
                break;
        }

        return null;

    }

    FormStepArtefact(mode, seq, Artefact = {}){
        return(
            <StepArtefactRow key={seq.toString()} mode={mode} parent={this} Artefact={Artefact} seq={seq} Process={this.state.Process} seqStep={this.state.seqStep}/>
        )
    }

    addArtefact(){

        let FormData = {...this.state.FormData};
        FormData.Artefacts = [...(FormData.Artefacts || []), {}];
  
       this.setState({"FormData": FormData});

    }

    removeArtefact(seq){

       let FormData = {...this.state.FormData};
       FormData.Artefacts = [...(FormData.Artefacts || [])];
       FormData.Artefacts.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});

    }


    updateArtefact(seq, Artefact){

       let FormData = {...this.state.FormData};
       FormData.Artefacts = [...(FormData.Artefacts || [])];
       FormData.Artefacts[seq-1] = Artefact;

       this.setState({"FormData": FormData});

    }

    FormStepResources(){

        if (!this.state.FormData.type){
            return null
        }

        let modelStep = null;
        if (this.state.FormData.type in this.dsd.model.steps){
            modelStep = this.dsd.model.steps[this.state.FormData.type];
        }
        if (!modelStep){
            return null
        }

        let seqNext = 1;

        switch (modelStep.type){
            case 'bpmn:activity':
            case 'bpmn:exclusiveor':
            case 'bpmn:inclusiveor':
                if (this.state.FormData.Resources){
                    seqNext = this.state.FormData.Resources.length + 1;
                }
                return (
                    <fieldset>
                        <legend>Resources - more information about this step</legend>
                        <PD.Table type="list">
                            {this.state.FormData.Resources &&
                                this.state.FormData.Resources.map(
                                    (stepResource, posStepResource) => 
                                    {
                                        let seq = posStepResource+1;
                                        return(
                                            this.FormStepResource('edit', seq, stepResource)
                                        )
                                    }
                                )
                            }
                            {this.FormStepResource('new', seqNext)}
                        </PD.Table>
                    </fieldset>
                );
                break;
        }

        return null;

    }

    FormStepResource(mode, seq, Resource = {}){
        return(
            <StepResourceRow key={seq.toString()} mode={mode} parent={this} Resource={Resource} seq={seq} Process={this.state.Process} seqStep={this.state.seqStep}/>
        )
    }

    addResource(){

        let FormData = {...this.state.FormData};
        FormData.Resources = [...(FormData.Resources || []), {}];
  
        this.setState({"FormData": FormData});

    }

    removeResource(seq){

       let FormData = {...this.state.FormData};
       FormData.Resources = [...(FormData.Resources || [])];
       FormData.Resources.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});


    }


    updateResource(seq, Resource){

       let FormData = {...this.state.FormData};
       FormData.Resources = [...(FormData.Resources || [])];
       FormData.Resources[seq-1] = Resource;

       this.setState({"FormData": FormData});

    }


};

// Wrap and export
export default function Step_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Step {...props} navigation={navigation} location={location} params={params} />;
  }
